/**
 * API-related error codes.
 * All API errors are logged with API_REQUEST_FAILED by the axios interceptor.
 */
export enum ApiErrorCode {
  API_REQUEST_FAILED = 'error.api.request.failed',
}
